<template>
    <div class="bckdiv">
      <v-container fluid grid-list-md>
          <v-layout row wrap align-center justify-center>
              <v-flex xs12 md12 sm12 style="margin-top:90px">
                  <h2 style="text-align:center;padding-top:20px;color:#e91e63">Management</h2><br/></v-flex>
              <v-flex xs12 md2 style="padding:15px">
                  <v-card class="redius elevation-7 prdct" style="height:330px">
                 <v-container>

                   <img style="border-radius:4%" src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcREp66Nvh6g9BhXhhPiXCgqkEI6dVR9DgynnLjQGzHYmD-kfGQH" width="100%" height="170px" />

                  <v-card-text class="justify-content: center">
                    <h5 style="text-align:center;color:#e91e63">Aviishek Maity</h5>
                     <h4 style="text-align:center">Founder & Director</h4>
                    </v-card-text>
                     </v-container>
                  </v-card>
              </v-flex>
              <v-flex xs12 md2 style="padding:15px">
                  <v-card class="redius elevation-7 prdct">
                 <v-container>

                   <img style="border-radius:4%" src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQiOO2nULQtxvEUbVEJLI6SnziqhnqaWwyYncS0d4rWKZPPu87E" width="100%" height="170px" />

                  <v-card-text class="justify-content: center">
                    <h5 style="text-align:center;color:#e91e63">Roma Dhar</h5>
                     <h4 style="text-align:center">Director</h4>
                    </v-card-text>
                     </v-container>
                  </v-card>
              </v-flex>
              <v-flex xs12 md2 style="padding:15px">
                  <v-card class="redius elevation-7 prdct">
                 <v-container>

                   <img style="border-radius:4%" src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQU4vKFoGPARa3DJS9iSBE6jl029uXxjdt9ydCZzZ1V5Ru8Y-Ed" width="100%" height="170px" />

                  <v-card-text class="justify-content: center">
                    <h5 style="text-align:center;color:#e91e63">Shyam Kr Dhar</h5>
                     <h4 style="text-align:center">Co-Director</h4>
                    </v-card-text>
                     </v-container>
                  </v-card>
              </v-flex>

              <!-- <v-flex md8 sm8 xs12 style="text-align:center;padding-top: 200px;padding-right: 20px">
                  <div class="opct">
                      <v-icon color="#ff336d" size="50">help_outline</v-icon>
                      <h2 class="white--text">How can I help you?</h2>
                      <h3 class="white--text">Call Us</h3>
                      <p class="white--text contact_tag">+91 6290398678</p>
                      <h3 class="white--text">or Email Us</h3>
                      <p class="white--text contact_tag">info@aimroindia.com</p>
                  </div>
              </v-flex>

              <v-flex md4 sm4 xs12 class="help" style="padding-top: 70px;padding-right: 20px">
                  <v-container>
                      <v-card class="elevation-5 opct">
                          <h2 style="text-align:center;padding-top:20px;" class="enquiry">Drop us a line</h2>
                          <p style="text-align:center; color:#ff336d" class="contact_tag">We’d love to hear from you</p>
                            <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12 md2 sm2></v-flex>
                         <v-flex xs12 md8 sm8>
                           <v-text-field v-model="form1.name" label="Name"></v-text-field>

                           <v-text-field v-model="form1.name" label="Email"></v-text-field>

                           <v-text-field type="Number" v-model="form1.name" label="Phone number"></v-text-field>

                           <v-textarea v-model="form1.comment" label="Comment" ></v-textarea>
                         </v-flex>

                         <v-flex xs12 md2 sm2></v-flex>

                         <br>

                         <v-flex xs12 md2 sm2></v-flex>
                         <v-flex xs12 md8 sm8>
                           <v-btn style="margin-bottom:30px" color="#ff336d" class="white--text" large block depressed @click="enquiry()">Submit</v-btn>
                         </v-flex>

                         <v-flex xs12 md2 sm2></v-flex>
          
                       </v-layout>
                     </v-form>
                      </v-card>
                   </v-container>
                             </v-flex> -->
                         </v-layout>
                         
              </v-container>
    </div>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
        
    };
  },
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Bree+Serif|Squada+One&display=swap');
</style>

<style scoped>
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}
.bckdiv {
    background-image: url("../../assets/contact.jpg");
    background-size: cover;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
    font-family: 'Space Mono', monospace;
}
@media screen and (max-width: 763px) {
  .rspnsv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    background-position: center;
    background-size: cover;
  }
  .help {
    padding-right: 0px !important;
  }
  .aboutTop {
      margin-top: 180px;
      margin-bottom: 100px;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
  .mngmnt {
      margin-top: 100px;
  }
}
</style>
